import React from 'react';

interface FloorPlanTabProps {
  selectedFloor?: string;
  onFloorChange?: (floor: string) => void;
  onRefresh?: () => void;
  onFullscreen?: () => void;
  onSettings?: () => void;
}

const FloorPlanTab: React.FC<FloorPlanTabProps> = ({
  selectedFloor,
  onFloorChange: _onFloorChange,
  onRefresh: _onRefresh,
  onFullscreen: _onFullscreen,
  onSettings: _onSettings
}) => {
  return (
    <div style={{ padding: '40px', textAlign: 'center' }}>
      <h3>平面图视图开发中...</h3>
      <p>将支持空间的平面图可视化展示</p>
      <p>当前选择楼层: {selectedFloor || '未选择'}</p>
    </div>
  );
};

export default FloorPlanTab;
